import React from 'react';
import PopupText from './popupText'

export default class Candlestick extends React.Component {
    static defaultProps = { multiplier: 20 };

    componentWillMount() {
        this.calculate(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.multiplier !== this.props.multiplier || nextProps.x !== this.props.x || nextProps.y !== this.props.y) {
            this.calculate(nextProps);
        }
    }

    calculate(values) {
        this.setState({
            data: values.data,
            charW: 0.25 * values.multiplier,
            xPos: values.x + values.xPos * values.multiplier,
            low: values.y - values.data[0] * values.multiplier,
            midL: values.y - values.data[1] * values.multiplier,
            midH: values.y - values.data[2] * values.multiplier,
            high: values.y - values.data[3] * values.multiplier,
        });
        this.setState((prevState) => ({
            shadowLower: `M ${prevState.xPos - prevState.charW} ${prevState.low} H ${prevState.xPos + prevState.charW} M ${prevState.xPos} ${prevState.low} V ${prevState.midL} `,
            shadowUpper: `M ${prevState.xPos} ${prevState.midH} V ${prevState.high} M ${prevState.xPos - prevState.charW} ${prevState.high} H ${prevState.xPos + prevState.charW} `,
        }));
    }

    render() {
        return (
            <g className="candlestickOne">
                <path d={this.state.shadowLower}
                      stroke="black"
                      strokeWidth={1}
                      fill="none"
                />
                <rect
                    x={this.state.xPos - this.state.charW}
                    y={this.state.midH}
                    width={this.state.charW * 2}
                    height={this.state.midL - this.state.midH}
                    stroke="black"
                    strokeWidth={1}
                    fill="white"
                />
                <path d={this.state.shadowUpper}
                      stroke="black"
                      strokeWidth={1}
                      fill="none"
                />
                <PopupText data={this.state.data}
                           x={this.state.xPos}
                           y={this.state.midH}
                />
            </g>
        );
    }
}



// WEBPACK FOOTER //
// ./src/graph-components/candlestick.js